export default __webpack_public_path__ + "static/media/energy_vampire.cb9b7ae3.png";